import { Pipe, PipeTransform } from '@angular/core';
import { ImportState } from '@app/shared/enums/ImportState.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'importState',
    standalone: false
})
export class ImportStatePipe implements PipeTransform {
  public importState = ImportState;
  public importStatesList: any[] = [];

  constructor(public translate: TranslateService) { 
    this.getList();
  }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(ImportState).find(
          k => ImportState[k as keyof typeof ImportState] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.importStatesList = [];

    for (const [propertyKey, propertyValue] of Object.entries(ImportState)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.importStatesList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.importStatesList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ImportState)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return { id: propertyValue, name: nameAndText, text: nameAndText };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ImportState)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
